import React from 'react';
import Datatable from '../../../../components/molecules/datatable';
import { TableColumns } from '../../configuration';
import { useDispatch } from 'react-redux';
import ApplicantActions from '../../../../redux/reducers/applicant_list_reducer/actions';
import * as ApplicantSelector from '../../../../redux/reducers/applicant_list_reducer/selectors';
import * as AuthSelectors from 'redux/reducers/gl_auth_reducer/selectors';

export default function DatatableList() {
  // console.log('Render Applicant DataTable');
  const ROLE = AuthSelectors.useSelectUserRole();
  const result = ApplicantSelector.useGetApplicants();
  const paging = result.data?.paging;
  const dispatch = useDispatch();
  const sortField = React.useRef<string>(TableColumns(ROLE)[0].id);
  const sortType = React.useRef<'asc' | 'desc'>('asc');

  return (
    <Datatable
      loading={true}
      sorting={{
        sortField: sortField.current,
        order: sortType.current,
      }}
      paging={paging}
      data={result.data?.items || []}
      columns={TableColumns(ROLE)}
      changePageHandle={(selectedPage, pageSize, order, _sortField) => {
        sortType.current = order;
        sortField.current = _sortField;
        dispatch(
          ApplicantActions.fetchApplicantsAction({
            sortField: _sortField,
            page: selectedPage,
            pageSize: pageSize,
            order: order,
          })
        );
      }}
    />
  );
}
